import { LinkButton } from "@digipost/dds-buttons-react";
import { Language, useLanguage } from "@digipost/translate";
import { FC } from "react";

import Translated from "./Translated";
import { AVAILABLE_LANGUAGES } from "./translatedUrls";

const LanguageLink: FC<{
  language: Language;
  style: string;
}> = ({ language, style }) => {
  const { setLanguage } = useLanguage();

  return (
    <LinkButton
      onClick={() => {
        setLanguage(language);
      }}
      className={style}
    >
      <Translated textKey={`generic.language_${language}`} />
    </LinkButton>
  );
};

export const LanguageLinks: FC<{
  style: string;
  listStyle?: string;
}> = ({ style, listStyle }) => {
  return (
    <>
      {AVAILABLE_LANGUAGES.map((language) => (
        <li key={language} className={listStyle}>
          <LanguageLink language={language} style={style} />
        </li>
      ))}
    </>
  );
};
